

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"33","height":"32"}, rest), [h('path', {"fill":"#FEFEFE","fill-rule":"evenodd","d":"M14.608 5l-.012 14.822 2.835-1.596.001-13.212h6.073l-.013 14.723 2.838-1.511L26.318 5h.036c.187.003 1.09.013 2.133.013 1.402 0 3.005 1.303 3.005 3.4l.001 2.194.007 8.961c0 .524-.308.828-.66 1.07l-11.863 6.743c-.782.375-1.546-.251-1.54-1.129.003-.563-.004-2.962-.004-2.962s-7.327 4.068-7.333 4.07c-.709.347-1.558-.165-1.558-1.075l-.001-2.893L8.536 7.4a2.4 2.4 0 012.4-2.401h3.672zM5.923 8.926v15.58L1.5 18.723v-7.36c0-1.285.911-2.437 2.24-2.437h2.183z"}, [])]);
};

        